import { render, staticRenderFns } from "./UrunFiltrele.vue?vue&type=template&id=b1851f34&scoped=true"
import script from "./UrunFiltrele.vue?vue&type=script&lang=js"
export * from "./UrunFiltrele.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1851f34",
  null
  
)

export default component.exports